import {useEffect, useState} from 'react';
import {notification} from 'antd';
import {Package, Level, Curriculum} from '../../../graphql/API';
import {PackagesService} from '../../Package';
import {LevelsService} from '../../Level';
import {CurriculumsService} from '../../Curriculums/CurriculumsService';
import {getCurrentUserPermission, Permissions} from '../../../utils';

const packagesService = new PackagesService();
const levelService = new LevelsService();
const curriculumsService = new CurriculumsService();

export const useDiscountCodeData = () => {
  const [packages, setPackages] = useState<Package[]>([]);
  const [levels, setLevels] = useState<Level[]>([]);
  const [curriculums, setCurriculums] = useState<Curriculum[]>([]);
  const [permission, setPermission] = useState<Permissions>();
  const [isLoadingMeta, setIsLoadingMeta] = useState(true);

  useEffect(() => {
    getCurrentUserPermission()
      .then((p: Permissions) => {
        setPermission(p);
        if (p !== 'admin') {
          setIsLoadingMeta(false);
          return;
        }

        Promise.allSettled([
          packagesService.getPackages(1, 100),
          curriculumsService.getCurriculums(),
        ]).then(([pkgs, currs]) => {
          if (pkgs.status === 'fulfilled') setPackages(pkgs.value.items as any);
          if (currs.status === 'fulfilled') {
            setCurriculums(currs.value);
          }
          setIsLoadingMeta(false);
        });
      })
      .catch(() => setIsLoadingMeta(false));
  }, []);

  const loadLevels = () => {
    if (levels.length > 0) return;
    levelService
      .getLevels()
      .then(setLevels)
      .catch(() => notification.error({message: 'Failed to load levels'}));
  };

  return {packages, levels, curriculums, permission, isLoadingMeta, loadLevels};
};
